module.exports = __webpack_public_path__ + "static/img/5.9b124f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/5.png
// module id = LKEF
// module chunks = 0